/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';

import { showError } from '../App/AppAlert';
import connectData, { ConnectedProps } from '../../support/connectData';
import AccountActions from '../../support/AccountActions';
import { postJSON } from '../../support/Fetch';
import toProperName from '../../support/helpers/toProperName';
import ensureObject from '../../support/shared/ensureObject';
import {
  DEFAULT_SETTINGS,
  INVOICE_PROVIDERS,
} from '../../support/shared/constants/Constants';
import { canUser } from '../../support/shared/permissionHelpers';

import { Card, Page, RadioGroup, RadioItem, Text, Link } from '../uiold';

import settingsStyles from './styles';
import FreshbooksSettings from './FreshbooksSettings';
import QuickbooksSettings from './QuickbooksSettings';

import { Account } from '../../types/shared/Account';

type State = {
  invoiceProvider: string;
};

class InvoiceSettings extends Component<FullProps, State> {
  state: State = {
    invoiceProvider: getInvoiceProvider(this.props.account),
  };

  render() {
    return (
      <Page>
        <Page.Header title="Accounting and Invoicing" />
        <Card>
          <Text>
            MarketWurks supports integration with{' '}
            <Link href="https://www.freshbooks.com/">Freshbooks</Link> or{' '}
            <Link href="https://quickbooks.intuit.com/">Quickbooks</Link> for
            accounting and invoicing. If you have an account with{' '}
            <Link href="https://www.freshbooks.com/">Freshbooks</Link> or{' '}
            <Link href="https://quickbooks.intuit.com/">Quickbooks</Link> you
            can connect it with MarketWurks allowing you to easily create and
            send invoices to your vendors.
          </Text>
          {this._renderControl()}
          {this._renderSettings()}
        </Card>
      </Page>
    );
  }

  _renderControl = () => {
    let { invoiceProvider } = this.state;
    let { user } = this.props;
    let canEdit = user && canUser(user, { settings: 'WRITE' });

    let radioItems = Object.keys(INVOICE_PROVIDERS).map((provider) => (
      <RadioItem
        style={settingsStyles.radioItem}
        title={toProperName(provider)}
        key={provider}
        value={provider}
      />
    ));

    return (
      <RadioGroup
        onChange={canEdit ? this._onChange : () => null}
        selectedValue={invoiceProvider}
        style={styles.rowFlexed}
      >
        {radioItems}
      </RadioGroup>
    );
  };

  _renderSettings = () => {
    let { account } = this.props;
    let { invoiceProvider } = this.state;
    if (!account) {
      return null;
    }
    switch (invoiceProvider) {
      case 'freshbooks':
        return <FreshbooksSettings account={account} />;
      case 'quickbooks':
        return <QuickbooksSettings account={account} />;
    }
  };

  _onChange = (value: unknown) => {
    if (
      typeof value === 'string' &&
      Object.keys(INVOICE_PROVIDERS).includes(value as any)
    ) {
      this.setState({ invoiceProvider: value });
      this._onSave(value);
    }
  };

  _onSave = (invoiceProvider: string) => {
    let { account } = this.props;

    if (account) {
      let accountID = account.id;
      let updates = { invoice_provider: invoiceProvider };
      let postData = { account: { settings: updates } };
      postJSON(
        `/api/accounts/${accountID}/settings`,
        postData,
        (error, data) => {
          if (error) {
            console.error(error); // eslint-disable-line no-console
            let errorObject = ensureObject(error);
            let errorMessage = errorObject
              ? String(errorObject.message)
              : String(error);
            showError(`Unable to complete request: ${errorMessage}`);
            return;
          }
          if (data.success) {
            AccountActions.updateSettings(updates);
          }
        },
      );
    }
  };
}

let styles = StyleSheet.create({
  rowFlexed: {
    flexDirection: 'row',
  },
});

function getInvoiceProvider(account: Account | null | undefined) {
  return account && account.settings && account.settings.invoice_provider
    ? account.settings.invoice_provider
    : DEFAULT_SETTINGS.invoice_provider;
}

const connector = connectData()(() => ({
  account: { dataStoreKey: 'account' },
  user: { dataStoreKey: 'user' },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(InvoiceSettings);
